import { cleanObject } from './cleanObject.js';

export const internalStackStrings = ['/gravity', '/node_modules', 'file:///'];

export const isInternalStack = (line) => {
  return internalStackStrings.some((str) => line?.includes?.(str));
};

export const sanitizeStack = (stack = '') => {
  const stackLines = stack?.split?.('\n');
  const firstLine = stackLines?.[0];
  const filteredStackLines = stackLines?.slice?.(1)?.filter?.((line) => !isInternalStack(line));
  return [firstLine, ...filteredStackLines].join('\n');
};

export const formatErrorAsObject = (obj, hideStack = false) => {
  const isAggregate = (typeof AggregateError !== 'undefined' && obj instanceof AggregateError) || obj?.name === 'AggregateError' || Array.isArray(obj?.errors);

  if (isAggregate) {
    const aggregate = cleanObject({
      name: obj?.name,
      message: obj?.message,
      stack: obj?.stack ? (hideStack ? sanitizeStack(obj.stack) : obj.stack) : undefined,
      errors: Array.isArray(obj?.errors)
        ? obj.errors.map((e) => {
            if (!e || !e?.message || !e?.stack) {
              return e;
            }
            const formatted = {
              message: e.message,
              stack: hideStack ? sanitizeStack(e.stack) : e.stack
            };
            if (e?.name) {
              formatted.name = e.name;
            }
            if (e?.code) {
              formatted.code = e.code;
            }
            return formatted;
          })
        : []
    });

    return aggregate;
  }

  if (!obj || !obj?.message || !obj?.stack) {
    return obj;
  }

  if (!hideStack) {
    return {
      message: obj.message,
      stack: obj.stack
    };
  }

  const sanitizedStack = sanitizeStack(obj.stack);

  return {
    message: obj.message,
    stack: sanitizedStack
  };
};
